module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo07-nikon_thumb-9f30b0925e9015007d786db9800ec030.jpg";